module.exports = __webpack_public_path__ + "static/media/Footer_Bg.1d39cdb5.png";